import { Fragment } from "react";

import FormOne from "./FormOne";
import FormThree from "./FormThree";
import AudienceButtons from "./Button";
import HalfDial from "./HalfDial";
import EditButtons from "../../../components/EditButtons";
import { PageHeader, Paper } from "../../../components";
import ContributorCategories from "./CategoriesPaper";
import CampaignActivation from "./CAmpaignActivationPaper";
import CampaignActivationComingSoon from "./ComingSoonChannels";
import QuickSegments from "./ReadyMadeCohorts";

export default function FormDisplay({
  state,
  dispatch,
  fields,
  editState,
  setEditState,
  formikProps,
  setFields,
  segments,
  activeIndexes,
  setActiveIndexes,
  includedSegments,
  setIncludedSegments,
  messages,
  disaptchMessage,
}) {
  return (
    <Fragment>
      <PageHeader
        pageName={"Audience Creation"}
        pageHeader={
          formikProps.values.ID
            ? "Edit audience configuration and save changes"
            : "Click on a section (Preferences, Purchase, or Media) from the dial below to choose the right audience filters."
        }
        buttons={[
          !editState && (
            <EditButtons editState={editState} setEditState={setEditState} />
          ),
        ]}
      />

      <Paper style={{ justifyContent: "center", display: "flex" }}>
        <HalfDial
          dispatch={dispatch}
          state={state}
          setIncludedSegments={setIncludedSegments}
          segments={segments}
          activeIndexes={activeIndexes}
          setActiveIndexes={setActiveIndexes}
          editState={editState}
        />
      </Paper>

      {activeIndexes.length > 0 ? (
        <Fragment>
          <FormOne
            messages={messages}
            disaptchMessage={disaptchMessage}
            includedSegments={includedSegments}
            setFields={setFields}
            state={state}
            dispatch={dispatch}
            fields={fields}
            formikProps={formikProps}
            editState={editState}
            setEditState={setEditState}
          />

          <FormThree
            messages={messages}
            disaptchMessage={disaptchMessage}
            state={state}
            dispatch={dispatch}
            fields={fields}
            formikProps={formikProps}
            editState={editState}
            setEditState={setEditState}
          />

          <AudienceButtons
            state={state}
            messages={messages}
            disaptchMessage={disaptchMessage}
            ID={formikProps.values.ID}
            editState={editState}
            setEditState={setEditState}
            formikProps={formikProps}
          />
        </Fragment>
      ) : (
        <Fragment>
          <ContributorCategories />
          <QuickSegments />
          <CampaignActivation />
          <CampaignActivationComingSoon />
        </Fragment>
      )}
    </Fragment>
  );
}
